import ABCyaLib from '@abcya/abcya_lib';
import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import { getGameBackground } from '../scenes/GameBackground';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';
import CupStack from './CupStack';

export default class CupStackGameLevel extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   * @param {number} x 
   * @param {number} y 
   */
  constructor(scene) {
    super(scene);

    this.allStacking = true;
    this.cupsAdded = [];
    this.cupsTossed = 0;
    this.cupStartY = getGameBackground().horizon + 170;

    /** @type {CupStack[]} */
    this.allStacks = [];
  }

  createAllStacks() {
    //split letters up first into 2 or 3 arrays scrambled
    this.stackColors = ["red", "blue", "yellow"];
    this.allStacks = [];
    let alphaStr = "abcdefghijklmnopqrstuvwxyz";
    let letters = alphaStr.split("");
    //create stacks based on portrait width - a little space for side;
    this.createStack(letters, 728);
  }

  /**
   * 
   * @param {string[]} letters 
   * @param {*} spaceLeft 
   */
  createStack(letters, spaceLeft) {
    let arr = [];
    let maxAmount = this.getMaxStackSize(spaceLeft);
    if (maxAmount > letters.length) maxAmount = letters.length;

    let randomStackSize = Phaser.Math.Between(3, maxAmount);
    while (arr.length < randomStackSize) {
      let randomLetter = letters.splice(Phaser.Math.Between(0, letters.length - 1), 1);
      arr.push(randomLetter);
    }

    let randomColor = this.stackColors.splice(Phaser.Math.Between(0, this.stackColors.length - 1), 1);
    let stack = new CupStack(this.scene, 0, 0, arr, this, randomColor);
    stack.once("STACK_COMPLETE", this.handleStackComplete, this);
    this.allStacks.push(stack);
    spaceLeft -= stack.getTotalStackWidth();
    let possibleNextSize = this.getMaxStackSize(spaceLeft);

    if (letters.length >= 3 && possibleNextSize >= 3) {
      this.createStack(letters, spaceLeft);
    }
    else {
      this.checkStackFilter();
    }
  }

  checkStackFilter() {
    //checks for bad words across the stacked cups, I'll need to add another check if they will be stacked in front first to check for all possible showing after some are typed
    let hasBadWords = false;

    //find highest stack/ how many levels need checking
    let stackHeights = [];
    let stacks = 0;
    while (stacks < this.allStacks.length) {
      stackHeights.push(this.allStacks[stacks].stackLetters.length);
      stacks++;
    }
    const highestStack = Math.max(...stackHeights);

    //get string from each level across all stacks to check bad word filter
    let checkLevel = 0;
    while (checkLevel < highestStack) {
      let levelString = "";
      for (let s = 0; s < this.allStacks.length; s++) {
        /** @type {string[][][][]} */
        let checkStack = this.allStacks[s].stackLetters;

        /**
         * The data structure for the stack letters is a bit wonky, it's a 4 deep array of single characters.
         * The letter can be gotten by doing checkStack[row][indexOfLetter][0][0] where:
         *      row: is the row of the cups, with 0 being the bottom row
         *      indexOfLetter is the index of the letter you want to get
         */
        //is stack as high as current level being checked
        if (checkStack.length > checkLevel) {
          checkStack[checkLevel].forEach(letterContainer => levelString += letterContainer[0][0]);
        }
      }

      hasBadWords = this.checkBadWords(levelString);
      if (hasBadWords) break;
      checkLevel++;
    }

    //continue or shuffle and try again
    if (hasBadWords) {
      this.shuffleStacks();
      //add delay to complete shuffle?? messy but want to make sure its finished before recheck
      this.scene.time.delayedCall(20, this.checkStackFilter, null, this);
    }
    else {
      this.setUpLevel();
      this.emit("LEVEL_READY");;
    }
  }

  getStackSpacing() {
    let allStacksWidth = 0;
    for (let i = 0; i < this.allStacks.length; i++) {
      allStacksWidth += this.allStacks[i].getTotalStackWidth();
    }

    let spacing = (this.scene.scale.width - allStacksWidth) / (this.allStacks.length + 1);
    return spacing;
  }

  setUpLevel() {
    this.stacksToFinish = this.allStacks.length;
    let spacing = this.getStackSpacing();
    let offset = spacing;
    let stackY = this.cupStartY - 20;
    for (let i = 0; i < this.allStacks.length; i++) {
      this.allStacks[i].initStack(offset, stackY);
      offset += this.allStacks[i].getTotalStackWidth() + spacing;
    }

    this.setStacksReady();
  }

  getMaxStackSize(spaceAvailable) {
    //space divided by item width
    //get total in stack from that
    let sizerCup = this.scene.textures.getFrame(ABCyaPhaser.Images.DEFAULT_ATLAS, UIAssetKeys._game_items_cup_red_0);
    let cupWidth = sizerCup.width;
    let maxStackBase = Math.floor(spaceAvailable / cupWidth);

    return (maxStackBase * (maxStackBase + 1) / 2);
  }

  shuffleStacks() {
    for (let i = 0; i < this.allStacks.length; i++) {
      this.allStacks[i].shuffleStackPositions();
    }
  }

  /**
   * 
   * @param {string} str 
   * @returns true if the str contains a bad word
   */
  checkBadWords(str) {

    return ABCyaLib.BadWordFilter.checkTextForBadWords(str)
  }

  setStacksReady() {
    let allLocked = true;
    for (let i = 0; i < this.allStacks.length; i++) {
      let stack = this.allStacks[i];

      let ready = false;
      if (this.allStacking == true) {
        if (stack.stackOrUnstack == "stack") {
          if (i == 0) ready = true;
          if (i > 0 && this.allStacks[i - 1].stackOrUnstack == "unstack") ready = true;
        }
      }
      else {
        if (stack.stackOrUnstack == "unstack" && stack.stackComplete == false) {
          if (i == 0) ready = true;
          if (i > 0 && this.allStacks[i - 1].stackComplete == true) ready = true;
        }
      }

      if (stack.stackReady != ready) {
        stack.stackReady = ready;
        stack.checkPositionsReady();
      }
      stack.stackReady = ready;
      if (ready == true) {
        allLocked = false;
      }
    }

    if (this.allStacking == true && allLocked == true) {
      this.allStacking = false;
      this.setStacksReady();
    }
  }

  stackCup(letterValue) {
    let matched = false;
    let realLetter = letterValue.toString();

    let checkStack = null;
    for (let i = 0; i < this.allStacks.length; i++) {
      if (this.allStacks[i].stackReady == true) {
        checkStack = this.allStacks[i];
        break;
      }
    }

    if (checkStack == null) return;

    for (let j = 0; j < checkStack.readyPositions.length; j++) {
      let matchLetter = checkStack.readyPositions[j];
      if (matchLetter == realLetter) {
        matched = true;
        break;
      }
    }

    if (matched == true) {
      checkStack.inputToStackPosition(realLetter);
      this.setStacksReady();
    }
    else {
      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._incorrect_letter, this.scene);
      for (let r = 0; r < this.allStacks.length; r++) {
        checkStack.showAvailable();
        let flipLetters = this.allStacks[r].flipPositions;
        if (flipLetters.indexOf(realLetter) != -1) {
          let flipIndex = this.allStacks[r].getStackPositionIndex(realLetter);
          this.allStacks[r].flipPosition(flipIndex[0], flipIndex[1]);
          break;
        }
      }
    }
  }

  handleStackComplete(stack) {
    stack.stackReady = false;
    this.stacksToFinish--;
    if (this.stacksToFinish == 0) {
      this.cupsTossed = 0;
      this.scene.time.delayedCall(500, this.clearLevel, null, this);
    }
  }

  clearLevel() {
    let i = 0;
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._cups_leave_tween, this.scene);
    while (i < this.cupsAdded.length) {
      let cup = this.cupsAdded[i];
      cup.removeAllListeners();
      let endX = cup.x - this.scene.scale.width;
      if (endX > -cup.getBounds().width) endX = -cup.getBounds().width;
      ABCyaPhaser.Tweens.addTween(cup, 500, { x: endX, angle: -1440, delay: 50 * i }, Phaser.Math.Easing.Linear, this.trashCups.bind(this));
      i++;
    }
  }

  trashCups() {
    this.cupsTossed++;
    if (this.cupsTossed >= this.cupsAdded.length) {
      this.finishLevel();
    }
  }

  finishLevel() {
    this.emit("LEVEL_COMPLETE");
  }
}